import {useQuery} from "@tanstack/react-query";
import {readAccountShipmentInfoApi} from "../../../../../api/correspondent/CorresspondentApi";
import {CreateCorrespondentInterface} from "../../create/interface/CreateCorrespondentInterface";

type Props = {
    searchData: CreateCorrespondentInterface;
};

/**
 * 출하정보
 * @param param
 * @returns
 */
export const useReadAccountShipmentInfo = ({searchData}: Props) => {
    const {data} = useQuery({
        queryKey: ["readAccountShipmentInfo", searchData],
        queryFn: async () => await readAccountShipmentInfoApi(searchData),
        select: (res) => res?.result ?? null,
        // staleTime: 6000 * 10,
    });

    return {data};
};
